import { render, staticRenderFns } from "./v-button.vue?vue&type=template&id=5969c46d&scoped=true&"
import script from "./v-button.vue?vue&type=script&lang=js&"
export * from "./v-button.vue?vue&type=script&lang=js&"
import style0 from "./v-button.vue?vue&type=style&index=0&id=5969c46d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5969c46d",
  null
  
)

export default component.exports